import { Box, Stack, useDisclosure } from '@chakra-ui/react';
import { Button } from '@main/complykit';
import { useUserData } from '@nhost/react';

import { ImportCsvDataType, ImportDataFromCsvModal } from './import-data-from-csv';

export const TasksTab = ({ orgId }: { orgId: string }) => {
  const user = useUserData();
  const { isOpen: isImportOpen, onOpen: onOpenImport, onClose: onCloseImport } = useDisclosure();

  return (
    <Stack gap={8}>
      <Box alignSelf="end">
        <Button onPress={onOpenImport}>Import from CSV</Button>
      </Box>

      <ImportDataFromCsvModal
        key="import-tasks-modal"
        importType={ImportCsvDataType.TASK}
        orgId={orgId}
        email={user?.email}
        isModalOpen={isImportOpen}
        onModalClose={onCloseImport}
      />
    </Stack>
  );
};
